import React from 'react'

import DefaultButton from '../defaultButton/DefaultButton'

// This component is being DEPRECATED in favor of DefaultButton
const SecondaryButton = ({ ...props }) => {
  return <DefaultButton {...props} />
}

export default SecondaryButton
